import axios from 'axios';

const API = axios.create({ baseURL: 'https://webeng-project-smartservice-production.up.railway.app/api' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  verifyEmail: (data) => API.post('/auth/verify-email', data),
  getMe: () => API.get('/auth/me'),
  updateProfile: (data) => API.put('/auth/profile', data),
};

export const servicesAPI = {
  getAll: (params) => API.get('/services', { params }),
  getOne: (id) => API.get(`/services/${id}`),
  create: (data) => API.post('/services', data),
  update: (id, data) => API.put(`/services/${id}`, data),
  delete: (id) => API.delete(`/services/${id}`),
  getMyServices: () => API.get('/services/provider/myservices'),
};

export const bookingsAPI = {
  create: (data) => API.post('/bookings', data),
  getMy: () => API.get('/bookings/my'),
  updateStatus: (id, status) => API.put(`/bookings/${id}/status`, { status }),
  addReview: (id, data) => API.post(`/bookings/${id}/review`, data),
};

export const adminAPI = {
  getStats: () => API.get('/admin/stats'),
  getUsers: () => API.get('/admin/users'),
  getBookings: () => API.get('/admin/bookings'),
  getServices: () => API.get('/admin/services'),
  updateUser: (id, data) => API.put(`/admin/users/${id}`, data),
};

export const providersAPI = {
  getAll: () => API.get('/providers'),
  getDashboard: () => API.get('/providers/dashboard'),
};

export default API;
